import React from 'react';
import { useRecoilValue } from 'recoil';
import AccessInfoSelector from '../../recoil/selectors/AccessInfoSelector';

export default function FAQ() {
  const { network } = useRecoilValue(AccessInfoSelector);

  switch (network) {
    case 'meetme':
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1559091827329#ic_question" /></svg>
      );

    case 'lovoo':
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1511210228811#ic_lv_reward_faq" /></svg>
      );

    case 'vidoo':
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1511210228811#ic_vidoo_question" /></svg>
      );

    default:
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1511210228811#ic_question" /></svg>
      );
  }
}
